export const GET_CATALOGUE_REQUEST = 'essaysReducer/GET_CATALOGUE_REQUEST';
export const GET_CATALOGUE_SUCCESS = 'essaysReducer/GET_CATALOGUE_SUCCESS';
export const GET_CATALOGUE_FAILED = 'essaysReducer/GET_CATALOGUE_FAILED';
